<template>
  <div>
    <div class="flex justify-center mt-6">
      <img class="!h-52 !w-52" :src="qrCodeUrl" alt="" />
    </div>

    <div class="flex gap-4 mt-10 flex-col md:flex-row">
      <base-button class="!w-full" type="shade" @onClick="onCopyQrCode">
        <div class="flex gap-x-3">
          <svg-icon class="!w-6 !h-6" name="ic-copy" />

          <div class="font-normal">
            {{ $t('PaymentLinks | qrCodePayment') }}
          </div>
        </div>
      </base-button>

      <base-button class="!w-full" @onClick="onCopy">
        <div class="flex gap-x-3">
          <svg-icon class="!w-6 !h-6" name="ic-copy" />

          <div class="font-normal">
            {{ $t('PaymentLinks | copyLink') }}
          </div>
        </div>
      </base-button>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue'
import BaseButton from '@/shared/ui/BaseButton/BaseButton.vue'
import SvgIcon from '@/shared/ui/SvgIcon/SvgIcon.vue'
defineProps({
  qrCodeUrl: {
    type: String,
    required: true,
  },
  id: {
    type: [String, null],
    required: true,
  },
})

const emit = defineEmits(['copy-qr-code', 'copy-link'])

function onCopyQrCode() {
  emit('copy-qr-code')
}

function onCopy() {
  emit('copy-link')
}
</script>
